<div class="header-main" [ngClass]="{'with-overlay': modalView == MODAL_PENDING_CHANGES}">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == MODAL_PENDING_CHANGES"
        [type]="'warning'"
        [message]="'Editing tags'"
        [text]="'There are tag changes pending to save.<br/>If you continue, the changes made will be lost and not saved to the artwork.<br/>Do you wish to leave?'"
        [buttonText]="'OK'"
        (action)="onModalExitEdition()"
        [secondButtonText]="'Cancel'"
        (secondButtonAction)="onModalCancel()">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback"  *ngIf="modalView == MODAL_LABELS_UPDATE_ERROR" 
        [type]="'fail'"
        [message]="'Error'"
        [text]="'Something went wrong updating tags. Please try again. If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'Retry'" (action)="onModalErrorDismiss()">
    </core-layout-modal-feedback>
    <core-title-section [title]="title" [breadcrumbs]="breadcrumbs"></core-title-section>
    <div [hidden]="edit || version == null || exclude.length == 0" class="labels-header-container">

        <core-labels-text [labels]="exclude"></core-labels-text>
        <span class="plus" [hidden]="diffLabels.length == 0">+ </span>
        <core-labels-text [labels]="diffLabels"></core-labels-text>
    </div>
    <div class="loader" [hidden]="version != null">
        <div class="dimmed">
            <div class="dimmed_content">
                <div class="dimmed_flex">
                    <span class="dimmed_tag"></span>
                    <span class="dimmed_tag"></span>
                    <span class="dimmed_tag"></span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="edit && version != null" class="edit-tags-mod" [ngClass]="{'uploded-warning-displayed': uploaded }">

        <app-helpers-labels-edit-diff-box 
            [allowClose]="true" 
            [fullEditMode]="true"
            [project]="project"
            [labels]="version.labels"
            [headerText]="''" 
            [minLabels]="1"
            (labelsChange)="setLabels($event)" 
            (close)="toggleEdit()">
        </app-helpers-labels-edit-diff-box>
        <div class="box_fieldset">
            <core-helpers-forms-button-white 
                [disabled]="!pendingChanges || freezed" 
                [text]="'Save tags'"
                (click)="onTagsConfirm()">
            </core-helpers-forms-button-white>
        </div>
    </div>
    <version-helper-three-dot-status-update-menu 
        *ngIf="version != null && menu.length > 0"
        [version]="version"
        [menu]="menu" 
        (action)="onMenuSelect($event)" 
        (actionStatus)="onStatusMenuSelect($event)">
    </version-helper-three-dot-status-update-menu>
    <!-- bulkEdition -->
    <core-helpers-box-alert-message-icon 
        [hidden]="!edit" 
        [text]="alertText"
        [icon]="'warning'"></core-helpers-box-alert-message-icon>
</div>